module.exports = __webpack_public_path__ + "bddfbdbccff1aba6032c0d4ad2b9f4a3.svg";